import { Component, AfterViewInit } from '@angular/core';
import { StudentService } from '../../../shared-components/student/student.service';
import { StudentAddress } from './student-address.model';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-view-student-address',
    templateUrl: './view-student-address.component.html'
})
export class ViewStudentAddressComponent implements AfterViewInit {

    studentId: number;
    primaryAddress: StudentAddress;
    mailingAddress: StudentAddress;

    constructor(
        private studentService: StudentService,
        private dialog: MatDialogRef<ViewStudentAddressComponent>
    ) {
    }

    ngAfterViewInit() {
        this.studentService.getStudentAddresses(this.studentId).subscribe((addresses) => {
            this.primaryAddress = addresses.filter(a => a.Primary)[0];
            this.mailingAddress = addresses.filter(a => a.MailingAddress)[0];
        });
    }

    closeClick() {
        this.dialog.close();
    }

}